export default "__VITE_ASSET__7Qr6R7ML__"